<template>
  <div class="footer">
    <!-- footer-area -->
    <footer>
        <div class="footer__area-two">
            <div class="footer__top-two">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="footer-widget">
                                <div class="footer__content-two">
                                    <div class="fw-logo mb-25">
                                        <router-link to="/"><img src="assets/img/logo/brida.png" alt="brida" /></router-link>
                                    </div>
                                    <p>Website Resmi Badan Riset & Inovasi Daerah Kabupaten Konawe Selatan</p>
                                    <div class="footer__social-two">
                                        <ul class="list-wrap">
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-youtube"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-sm-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Kontak</h4>
                                <div class="footer-info-list footer-info-two">
                                    <ul class="list-wrap">
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-phone-call"></i>
                                            </div>
                                            <div class="content">
                                                <a href="tel:01234567890">+62 1234 5678 90</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-envelope"></i>
                                            </div>
                                            <div class="content">
                                                <a href="mailto:brida@konaweselatankab.go.id">brida@konaweselatankab.go.id</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-pin"></i>
                                            </div>
                                            <div class="content">
                                                <p>Jalan Poros Andoolo, Konawe Selatan, Sulawesi Tenggara</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-sm-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Menu</h4>
                                <div class="footer-link-list">
                                    <ul class="list-wrap">
                                        <li><router-link to="/berita">Berita</router-link></li>
                                        <li><router-link to="/pengumuman">Pengumuman</router-link></li>
                                        <li><router-link to="/profil">Profil Dinas</router-link></li>
                                        <li><router-link to="/tupoksi">Tugas Pokok</router-link></li>
                                        <li><router-link to="/visi">Visi Misi</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Foto Kegiatan</h4>
                                <div class="footer-instagram">
                                    <ul class="list-wrap">
                                        <li v-for="data, in list_foto" :key="data.id">
                                            <a><img :src="file_path+data.foto" alt="brida" /></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer__bottom-two">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="copyright-text-two">
                                <p>Copyright © <span>Diskominfo & Persandian</span> | All Right Reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- footer-area-end -->
  </div>
</template>

<script>

export default {
  name: 'Footer',
  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        list_foto : [],
    }
  },
  methods: {
    getFoto: function() {
        fetch(this.$store.state.url.URL_FOTO, {
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_foto = res_data
            console.log(res_data);
        });
    },
  },
  mounted() {
    this.getFoto();
  },
}
</script>
